<template>
  <div id="app">
    <template v-if="loaded">
      <SearchAPI v-if="isAnEventCalendar || isBusinessItems"></SearchAPI>
      <Search v-else> </Search>
    </template>
  </div>
</template>

<script>
  import Search from './components/Search.vue'
  import SearchAPI from './components/SearchAPI.vue'
  import calendar from '@/mixins/calendar'

  export default {
    name: 'app',
    mixins: [calendar],
    components: {
      Search,
      SearchAPI
    },
    data() {
      return {
        loaded: false,
      }
    },
    computed: {
      route () {
        return this.$route.name
      },
      isBusinessItems() {
        return this.route === 'business_items'
      },
    },
    mounted() {
      // Store authentication status; needed for showing the Delegate Modal.
      // const isAuthenticated = window.drupalSettings.searchSettings?.ac ?? null
      /** Delete the following line and uncomment the previous line to enable gating **/
      const isAuthenticated = true
      this.$store.commit('updateIsAuthenticated', isAuthenticated)
      this.loaded = true
    }
  }
</script>
